// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {FlatList} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {RefType} from '@supermove/hooks';
import {CommunicationModel, UserModel} from '@supermove/models';

// App
import EmptyState from '@shared/design/components/EmptyState';
import CommunicationsList from '@shared/modules/Communication/components/CommunicationsList';

const CommunicationsWidgetBody = ({
  viewer,
  conversations,
  conversationsScrollView,
  contactName,
}: {
  viewer: UserModel;
  conversations: CommunicationModel[];
  conversationsScrollView: {ref: RefType<typeof FlatList<CommunicationModel>>};
  contactName: string;
}) => {
  if (_.isEmpty(conversations)) {
    return (
      <EmptyState.ContentContainer>
        <EmptyState
          title={'No messages'}
          message={`Use the field below to call, email, or send text messages to ${contactName}.`}
        />
      </EmptyState.ContentContainer>
    );
  }
  return (
    <CommunicationsList
      conversations={conversations}
      conversationsScrollView={conversationsScrollView}
      viewer={viewer}
    />
  );
};

CommunicationsWidgetBody.fragment = gql`
  ${CommunicationsList.fragment}

  fragment CommunicationsWidgetBody_Viewer on User {
    id
    ...CommunicationsList_Viewer
  }

  fragment CommunicationsWidgetBody_Communication on Communication {
    id
    ...CommunicationsList_Communication
  }
`;

export default CommunicationsWidgetBody;
